import { render, staticRenderFns } from "./RouteLeafEmblem.vue?vue&type=template&id=062fee16&"
import script from "./RouteLeafEmblem.vue?vue&type=script&lang=js&"
export * from "./RouteLeafEmblem.vue?vue&type=script&lang=js&"
import style0 from "./RouteLeafEmblem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports